export abstract class GameView extends createjs.Container {
    titleScene: createjs.Container;
    gameScene: createjs.Container;
    protected width: number;
    protected height: number;
    constructor(width: number, height: number) {
        super();
        this.width = width;
        this.height = height;
        /*
        (async () => {
            // クラスの初期化
            await this.initClass();

            // 各画面の作成
            await this.createScenes();

            // コンテンツの初期化
            await this.initScenes();

            // ローディング画面の解除

        })();
        */
    }

    protected abstract async initClass(): Promise<void>;

    protected abstract async createScenes(): Promise<void>;

    protected abstract async initScenes(): Promise<void>;

}
